import { Dispatch } from "react";
import { AuthEnum, AuthRolType, getSessionExpiration } from "../auth.props";
import { LanguageEnum } from "../../language";

export const authActions = (dispatch: Dispatch<any>) => {
  const setLogin = (
    isLoggedIn: boolean,
    remember: boolean = false,
    session: string | undefined = undefined
  ) => {
    let expirationDate: string = "";

    if (session === undefined) {
      expirationDate = getSessionExpiration(remember);
      localStorage.setItem(AuthEnum.REMEMBER, `${remember}`);
    } else {
      expirationDate = session;
    }

    localStorage.setItem(AuthEnum.SESSION, expirationDate);
    localStorage.setItem(AuthEnum.LOGIN, `${isLoggedIn}`);
    dispatch({
      type: AuthEnum.SESSION,
      payload: expirationDate,
    });
    dispatch({ type: AuthEnum.LOGIN, payload: isLoggedIn });
    return;
  };

  const setToken = (token: string) => {
    localStorage.setItem(AuthEnum.TOKEN, token);
    dispatch({ type: AuthEnum.TOKEN, payload: token });
    return;
  };

  const setRefreshToken = (refreshToken: string) => {
    localStorage.setItem(AuthEnum.REFRESH_TOKEN, refreshToken);
    return;
  };

  const setUser = (user: any) => {
    localStorage.setItem(AuthEnum.USER, user ?? "");
    return dispatch({ type: AuthEnum.USER, payload: user });
  };

  const setRol = (rol: AuthRolType[]) => {
    localStorage.setItem(AuthEnum.ROL, JSON.stringify(rol));
    return dispatch({ type: AuthEnum.ROL, payload: rol });
  };

  const closeSession = () => {
    setLogin(false);
    setToken("");
    setUser(undefined);
    const keepKeys: string[] = [LanguageEnum.SET]; // Permite mantener el idioma seleccionado
    Object.keys(localStorage).forEach((key) => {
      if (!keepKeys.includes(key)) {
        localStorage.removeItem(key);
      }
    });
  };

  return {
    setLogin,
    setToken,
    setRefreshToken,
    setUser,
    setRol,
    closeSession,
  };
};
